import React, { FunctionComponent, useEffect } from "react";

export type Props = {
  id: string,
  content: string,
};

const polyfill = () => {
  // @ts-ignore
  if (typeof HTMLElement.prototype.setHTML === "function") {
    return;
  }
  // @ts-ignore
  HTMLElement.prototype.setHTML = function (input: string): void {
    // The TermsOfServiceDialog is using SanitizedHtml to put something from the
    // database into HTML. This is already low risk. Using setHTML only reduces
    // the risk further, it's not strictly needed. So using `this.innerHTML=` in
    // this polyfill re-introduces the risk for Safari users, but it's slightly
    // better than giving them a 100% broken experience.
    this.innerHTML = input;
  };
};
polyfill();

export const SanitizedHtml: FunctionComponent<Props> = props => {
  const { id, content } = props;

  useEffect(() => {
    const div = document.getElementById(id);
    // @ts-ignore
    div.setHTML(content);
  }, [id, content]);

  return <div id={id}/>;
};
